// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"f8ec13b7","158":"4b2e49ab","654":"6553046d","842":"1b8b8e69","877":"6dc0b989"}[chunkId] + ".chunk.css";
};